import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import { cn } from '../../lib/utils';
interface ModalProps {
  open: boolean;
  onClose: () => void;
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}
export function Modal({
  open,
  onClose,
  title,
  subtitle,
  children,
  className
}: ModalProps) {
  useEffect(() => {
    if (!open) return;
    const handler = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handler);
    document.body.style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', handler);
      document.body.style.overflow = '';
    };
  }, [open, onClose]);
  if (!open) return null;
  return <div role="dialog" aria-modal="true" className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-310">
      <div className="absolute inset-0 bg-slate-900/50 backdrop-blur-sm animate-in fade-in duration-150" onClick={onClose} data-id="element-311" />
      <div className={cn('relative bg-white rounded-2xl shadow-xl border border-slate-200 w-full max-w-2xl max-h-[90vh] flex flex-col animate-in fade-in zoom-in-95 duration-200', className)} data-id="element-312">
        <div className="flex items-start justify-between gap-4 p-6 border-b border-slate-200" data-id="element-313">
          <div className="min-w-0" data-id="element-314">
            {title && <h2 className="text-lg font-semibold text-slate-900 truncate" data-id="element-315">
                {title}
              </h2>}
            {subtitle && <div className="text-sm text-slate-500 mt-1" data-id="element-316">{subtitle}</div>}
          </div>
          <button type="button" onClick={onClose} aria-label="Close" className="shrink-0 h-8 w-8 inline-flex items-center justify-center rounded-lg text-slate-400 hover:text-slate-700 hover:bg-slate-100 focus:outline-none focus:ring-2 focus:ring-indigo-500" data-id="element-317">
            <X className="w-4 h-4" data-id="element-318" />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto p-6" data-id="element-319">{children}</div>
      </div>
    </div>;
}